import { useState, useRef } from "react";
import { useSession } from "next-auth/client";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Button,
} from "@chakra-ui/react";
import { AiOutlineDelete } from "react-icons/ai";
import { getAccount } from "utils/sessionHelper";
import { deleteTweet } from "controllers/schedule";
import { useMiscellaneousContext } from "context/miscellaneousContext";
import { DeleteIcon } from "components/icons/DeleteIcon";

interface Props {
  tweetId: string;
  isOpen: boolean;
  tweet: {
    id: string;
  }
  onClose: () => void;
}

export function DeleteTweet({ isOpen, onClose, tweetId, tweet }: Props) {
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const miscellaneousContext: any = useMiscellaneousContext();
  const cancelRef = useRef(null);
  const [session] = useSession();

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      const dataToSend: any = {
        thCustomClientId: getAccount(session)?.thCustomClientId,
        thCustomClientSecret: getAccount(session)?.thCustomClientSecret,
        thWriteAccessToken: getAccount(session)?.thWriteAccessToken,
        thWriteSecretToken: getAccount(session)?.thWriteSecretToken,
        thApp: getAccount(session)?.thApp,
        tweetId,
      };

      await deleteTweet(session, dataToSend, tweet);
      onClose();
      miscellaneousContext.publishedPanelRefresher({});
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <AlertDialog
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Delete this tweet from X
          </AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            Confirm you want to delete this tweet, and it will be deleted from
            X. This will also cancel any automated actions you planned
            such as retweets or auto DMs.
          </AlertDialogBody>

          <AlertDialogFooter justifyContent="center">
            <Button
              variant="secondaryDestructive"
              // colorScheme="red"
              // leftIcon={<AiOutlineDelete />}
              leftIcon={DeleteIcon}
              onClick={handleDelete}
              isLoading={isDeleting}
              ml={3}
            >
              Delete
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
}
